import { convertToObjById } from "../../../helpers/convertToObject";
import { convertToMapById } from "../../../helpers/convertToMap";
import { makeDirection } from "../../../helpers/makeDirection";
import { convertKeysToCamelCase } from "../../../helpers/remapingKeysToCamel";

export const EMPLOYEE_SELECTED = 'EMPLOYEE_SELECTED';
export const GET_EMPLOYEES = 'GET_EMPLOYEES';
export const GET_EMPLOYEES_DATA = 'GET_EMPLOYEES_DATA';
export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
export const MOD_EMPLOYEE = 'MOD_EMPLOYEE';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const RESET_EMPLOYEE_SELECTED = 'RESET_EMPLOYEE_SELECTED';
export const ADD_EMPLOYEE_MODE = 'ADD_EMPLOYEE_MODE';
export const EDIT_EMPLOYEE_MODE = 'EDIT_EMPLOYEE_MODE';
export const CHECK_ADD_EMPLOYEES_MODE_PERMIT = 'CHECK_ADD_EMPLOYEES_MODE_PERMIT';
export const DELETE_EMPLOYEE_MODE = 'DELETE_EMPLOYEE_MODE';
export const CLEAR_EMPLOYEES = 'CLEAR_EMPLOYEES';

const INITIAL_STATE = {
  employeeSelected: null,
  employeesObj: {},
  employeesArr: [],
  addEmployee: true,
  addMode: false,
  deleteMode: false,

  //Form options
  jobs: [],
  departments: [],
  contracts: [],
  jobsObj: {},
  departmentsObj: {},
  contractsObj: {}
};

export const employeesCatalogReducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

    case ADD_EMPLOYEE_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      };

    case EDIT_EMPLOYEE_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      };

    case DELETE_EMPLOYEE_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      };

    case CHECK_ADD_EMPLOYEES_MODE_PERMIT:
      return {
        ...state,
        addEmployee: action.payload,
      };

    case GET_EMPLOYEES_DATA:
      const { jobs, departments, contracts } = action.payload;
      return {
        ...state,
        jobs: jobs.sort((a, b) => a.label.localeCompare(b.label)),
        departments: departments.sort((a, b) => a.label.localeCompare(b.label)),
        contracts: contracts.sort((a, b) => a.label.localeCompare(b.label)),
        jobsObj: convertToObjById(jobs),
        departmentsObj: convertToObjById(departments),
        contractsObj: convertToObjById(contracts),
      };

    case GET_EMPLOYEES:
      const filteredEmployees = action.payload
        .filter(employee => employee?.name.length > 0)
        .map(employee => {
          const addressValues = convertKeysToCamelCase(employee.address);
          const fullName = `${employee.name} ${employee.lastName} ${employee.secondName}`;
          return {
            ...employee,
            job: state.jobsObj[employee.idJob]?.label,
            department: state.departmentsObj[employee.idDepartment]?.label,
            contract: state.contractsObj[employee.idContract]?.label,
            fullAddress: makeDirection(addressValues) || "",
            statusLabel: employee.status === 1 ? 'Activo' : 'Inactivo',
            fullName,
            value: employee.id,
            label: fullName
          };
        });

      const listEmployees = convertToObjById(filteredEmployees);
      return {
        ...state,
        employeesObj: listEmployees,
        employeesArr: filteredEmployees
      };

    case EMPLOYEE_SELECTED:
      return {
        ...state,
        employeeSelected: action.payload && state.employeesObj[action.payload]
      };

    case RESET_EMPLOYEE_SELECTED:
      return {
        ...state,
        employeeSelected: null
      };

    case CREATE_EMPLOYEE:
      const address = convertKeysToCamelCase(action.payload.address);
      const newEmployee = {
        ...action.payload,
        job: state.jobsObj[action.payload.idJob].label,
        department: state.departmentsObj[action.payload.idDepartment].label,
        contract: state.contractsObj[action.payload.idContract]?.label || null,
        fullAddress: makeDirection(address) || null,
        statusLabel: action.payload.status === 1 || action.payload.status === true ? 'Activo' : 'Inactivo'
      };
      const addingEmployee = [newEmployee, ...state.employeesArr];
      const newEmployees = convertToObjById(addingEmployee);
      return {
        ...state,
        employeesObj: newEmployees,
        employeesArr: addingEmployee
      };

    case MOD_EMPLOYEE:
      const addressValues = convertKeysToCamelCase(action.payload.address);
      const editedEmployees = {
        ...state.employeesObj,
        [action.payload.id]: {
          ...state.employeesObj[action.payload.id],
          ...action.payload,
          job: state.jobsObj[action.payload.idJob]?.label,
          department: state.departmentsObj[action.payload.idDepartment]?.label,
          contract: state.contractsObj[action.payload.idContract]?.label,
          fullAddress: makeDirection(addressValues) || null,
          statusLabel: action.payload.status === 1 || action.payload.status === true ? 'Activo' : 'Inactivo'
        },
      };
      return {
        ...state,
        employeesObj: editedEmployees,
        employeesArr: convertToMapById(editedEmployees)
      };
    case DELETE_EMPLOYEE:
      let newDelEmployees = {};
      Object.keys(state.employeesObj).forEach(key => {
        if (key !== action.payload) {
          newDelEmployees[key] = state.employeesObj[key];
        }
      });

      return {
        ...state,
        employeesObj: newDelEmployees,
        employeesArr: convertToMapById(newDelEmployees)
      };

    case CLEAR_EMPLOYEES:
      return INITIAL_STATE;

    default:
      return state;
  }
};